import { useNavigate } from "@/lib/router-compat";
import { Star } from "lucide-react";
import { useRewardBalance } from "@/hooks/useRewardBalance";

const CashBalanceChip = () => {
  const navigate = useNavigate();
  const { totalPoints, dollarBalance, loading } = useRewardBalance();

  if (loading || totalPoints === 0) return null;

  return (
    <button
      type="button"
      onClick={() => navigate("/rewards")}
      className="hidden sm:flex items-center gap-1.5 text-sm cursor-pointer hover:opacity-80 transition-opacity"
      aria-label={`Wallet balance: ${totalPoints} pts (${dollarBalance})`}
    >
      <Star size={16} className="text-accent" />
      <span className="font-semibold text-foreground">{totalPoints} pts</span>
      <span className="text-xs text-muted-foreground">({dollarBalance})</span>
    </button>
  );
};

export default CashBalanceChip;
